import { Box } from "@mui/material";
import mooneLogo from "Assets/Images/Images/moone-logo.svg";
import { BetaChip } from "Components/Beta/BetaChip";

export const MooneBetaLogo = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    gap={1.5}
    m={3}
  >
    <img src={mooneLogo} alt="Mo.one" width="120" />
    <BetaChip />
  </Box>
);
